"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.search");
var _AdditiveEdit = _interopRequireDefault(require("./AdditiveEdit.vue"));
var _AdditiveTable = _interopRequireDefault(require("./AdditiveTable.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'additive',
  // 菜品活动-加料推荐
  components: {
    AdditiveTable: _AdditiveTable.default,
    AdditiveEdit: _AdditiveEdit.default
  },
  data: function data() {
    return {
      activeName: 'table',
      additiveFnId: null
    };
  },
  created: function created() {},
  methods: {
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.additive_table.search();
    },
    addActivity: function addActivity() {
      this.activeName = 'config';
    },
    handleClick: function handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
      if (tab.name === 'table') {
        this.additiveFnId = null;
      }
    },
    editActivity: function editActivity(additiveFnId) {
      this.activeName = 'config';
      this.additiveFnId = additiveFnId;
    }
  }
};